import { fetchIncognitoRequestApi } from 'api/incognito/incognitoRequestApi'

export const FETCH_REQUEST_INCOGNITO_STATUS =
  'FETCH_REQUEST_INCOGNITO_STATUS' as const

export const fetchRequestIncognitoStatusAction = (userId: number | string) => ({
  type: FETCH_REQUEST_INCOGNITO_STATUS,
  promise: () => fetchIncognitoRequestApi(userId),
})
